export default function NoData() {
    return (
        <div className="card">
            <div className='card-body'>
                <p className='card-text'>No data</p>
            </div>
        </div>
    );
}
